import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    try {
      // Initialize Meta Pixel manually without npm package
      const pixelId = '3070568583125644';
      // Set up fbq function
      if (!(window as any).fbq) {
        const n = (window as any).fbq = function (...args: any[]) {
          if (n.callMethod) {
            n.callMethod.apply(n, args);
          } else {
            n.queue.push(args);
          }
        } as any;
        if (!(window as any)._fbq) (window as any)._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [] as any[];
        n.callMethod = null;
        // Load the Facebook pixel script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      ;
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
    } catch (e) {
      // Silently fail - pixel errors should never break the page
      console.warn('Meta Pixel initialization failed:', e);
    }
  }, []);
  return null;
}